import { render, staticRenderFns } from "./TaskTagTable.vue?vue&type=template&id=5953eee4&"
import script from "./TaskTagTable.vue?vue&type=script&lang=js&"
export * from "./TaskTagTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports